import { FormikValues } from 'formik'
import _ from 'lodash'
import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import DriverDocumentCreateViewEdit from '../../../Components/Common/DriverDocumentCreateViewEdit'
import UserContext from '../../../Context/UserContext'
import { getDocumentToEdit } from '../../../Services/DriverService'
import { PROJECT_ROUTES_ENUMS } from '../../../utils/enums/enums'
import { fetchResponseMessage } from '../../../utils/utils'

type Props = {}

const EditDriverDocument = (props: Props) => {
  const { t } = useTranslation()
  const params = useParams()
  const [selectedFormat, setSelectedFormat] = useState([] as any)
  const [doShowState, setDoShow] = useState(false)
  const [doseExpiryState, setDoseExpiry] = useState(false)
  const [isRequiredStateState, setIsRequiredState] = useState(true)
  const [isCaptureOnlyStateState, setIsCaptureOnlyState] = useState(false)
  const [documentNameState, setDocumentNameState] = useState('')
  const [documentDescriptionState, setDocumentDescriptionState] = useState('')
  const [documentSizeState, setDocumentSizeState] = useState(0)
  const [documentImageState, setDocumentImageState] = useState('')
  const [noDataFetched, setNoDataFetched] = useState(true)
  const { setArrayOfBreadCrumb, setIsFetching } = useContext(UserContext)

  useEffect(() => {
    (async () => {
      setIsFetching(true)
      try {
        const response = await getDocumentToEdit(params.itemId!)
        if (response.data) {
          setDocumentNameState(response.data.title)
          setDocumentDescriptionState(response.data.description)
          setDocumentSizeState(response.data.maxSize / 1000000)
          setDocumentImageState(response.data.placeHolderImg)
          setDoShow(response.data.doShowDocumentNumber)
          setDoseExpiry(response.data.doShowDocumentExpiryDate)
          setIsRequiredState(response.data.isRequired)
          setIsCaptureOnlyState(response.data.isCaptureOnly)
          const arrayOfContentType = response.data.contentType.split(',').map((formatType: string) => ({ value: formatType, label: formatType }))
          setSelectedFormat(arrayOfContentType)
          setIsFetching(false)
          setNoDataFetched(false)
        } else {
          throw response
        }
      } catch (error) {
        setIsFetching(false)
        console.error('🔥 ~ error', error)
        if (error && _.has(error, 'response.data.responseCode')) {
          // @ts-ignore
          const responseMessage = fetchResponseMessage(error.response.data.responseCode)
          console.log('🔥 ~ responseMessage', responseMessage)
          setTimeout(() => {
            toast.error(responseMessage)
          }, 2000)
        }
        // toast.error('could not get document Details')
      }
    })()

    setArrayOfBreadCrumb([
      { name: `${t('PAGE_NAME.HOME')}`, url: PROJECT_ROUTES_ENUMS.PRIVATE_ROUTES.HOME_PAGE },
      { name: `${t('PAGE_NAME.DRIVER_DOCUMENTS')}`, url: PROJECT_ROUTES_ENUMS.PRIVATE_ROUTES.DRIVER_DOCUMENT_PAGE },
      { name: `${t('PAGE_NAME.DRIVER_DOCUMENT_EDIT')}`, url: '' }
    ])
    return () => { }
  }, [])

  const setFieldValue = (formik: FormikValues) => {
    setSelectedFormat(formik.values.documentFormat)
    setDocumentNameState(formik.values.documentName)
    setDocumentDescriptionState(formik.values.documentDescription)
    setDocumentSizeState(formik.values.documentSize / 1000)
    setDocumentImageState(formik.values.documentImage)
  }
  return (
    <DriverDocumentCreateViewEdit
      field={{
        documentName: documentNameState,
        documentDescription: documentDescriptionState,
        documentSize: documentSizeState,
        documentImage: documentImageState,
        documentFormat: selectedFormat,
        setDoShow,
        setDoseExpiry,
        setIsRequiredState,
        setIsCaptureOnlyState,
        setSelectedFormat,
        setDocumentSizeState,
        doShow: doShowState,
        doseExpiry: doseExpiryState,
        isRequiredState: isRequiredStateState,
        isCaptureOnlyState: isCaptureOnlyStateState
      }}
      isDisabled={false}
      cardTitle={`${t('DRIVER_DOCUMENT_PAGE.DOCUMENT_EDIT_PAGE.TITLE')}`}
      submitButtonName="UPDATE"
      setFieldValue={setFieldValue}
      pageName="edit-driver-document"
      noDataFetched={noDataFetched}
    />
  )
}

export default EditDriverDocument
